import { render, staticRenderFns } from "./FSubmit.vue?vue&type=template&id=aa628f7e&"
import script from "./FSubmit.vue?vue&type=script&lang=js&"
export * from "./FSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports